import { guessBrowserLocale, rtlLocales } from '@cyren/common-lib';
import { atom, useRecoilState } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import { findLocaleByKey } from '../../app/use-app-state';
import type { SystemLocaleCodes } from '../../admin/hooks/locales/use-static-locale';
import { getLocaleCode } from '../pages/organization/configurations/language/constants';

const { persistAtom } = recoilPersist({ key: 'PatientLocalePersist' });

type PatientLocaleCookieT = {
  localeKey: string;
  userLocaleKey?: string | null;
};

export const PatientLocaleCookie = atom<PatientLocaleCookieT>({
  key: 'PatientLocaleCookie',
  default: {
    localeKey: guessBrowserLocale(),
    userLocaleKey: null,
  },
  effects_UNSTABLE: [persistAtom],
});

export function usePatientLocale() {
  const [patientLocaleCookie, setPatientLocaleCookie] = useRecoilState(PatientLocaleCookie);

  const { localeKey, userLocaleKey } = patientLocaleCookie;
  const localeInfo = findLocaleByKey(localeKey);
  const localeCode = (localeInfo?.code || getLocaleCode(localeKey) || 'en') as SystemLocaleCodes;

  const dir = rtlLocales.includes(localeKey || '') ? 'rtl' : 'ltr';
  const isRtl = dir === 'rtl';

  function setLocale(locale: string) {
    setPatientLocaleCookie({
      localeKey: locale,
      userLocaleKey: locale,
    });
  }

  function unsetLocale() {
    setPatientLocaleCookie({
      localeKey: 'english',
      userLocaleKey: null,
    });
  }

  return {
    localeKey,
    userLocaleKey,
    localeCode,
    localeInfo,
    dir,
    isRtl,
    setLocale,
    unsetLocale,
    patientLocaleCookie,
    setPatientLocaleCookie,
  };
}
